/**
 * Form, Inspection & Attachment Type Definitions.
 */

export interface FormFieldDefinition {
  name: string;
  label: string;
  type:
    | "text"
    | "number"
    | "select"
    | "checkbox"
    | "date"
    | "textarea"
    | "photo"
    | "pass_fail";
  required: boolean;
  options?: string[];
  placeholder?: string;
  section?: string;
  rating_type?: string;
}

export interface FormTemplate {
  id: string;
  organization_id: string;
  name: string;
  description: string | null;
  template_type: string;
  entity_type: string;
  category_filter: string[] | null;
  schema: FormFieldDefinition[];
  version: number;
  is_active: boolean;
  created_by: string | null;
  created_at: string;
  updated_at: string;
}

export interface FormTemplateCreate {
  name: string;
  description?: string;
  template_type?: string;
  entity_type?: string;
  category_filter?: string[];
  schema: FormFieldDefinition[];
}

export interface FormSubmission {
  id: string;
  form_template_id: string;
  entity_type: string;
  entity_id: string;
  data: Record<string, unknown>;
  overall_result: string | null;
  work_order_id: string | null;
  asset_id: string | null;
  inspector_notes: string | null;
  submitted_by: string | null;
  submitted_at: string;
  created_at: string;
}

export interface FormSubmissionCreate {
  entity_type: string;
  entity_id: string;
  data: Record<string, unknown>;
  work_order_id?: string;
  asset_id?: string;
  inspector_notes?: string;
}

export interface Attachment {
  id: string;
  organization_id: string;
  entity_type: string;
  entity_id: string;
  file_name: string;
  file_type: string;
  file_size: number;
  storage_path: string;
  uploaded_by: string | null;
  created_at: string;
}

export const FORM_FIELD_TYPES = [
  { value: "text", label: "Text" },
  { value: "number", label: "Number" },
  { value: "select", label: "Select" },
  { value: "checkbox", label: "Checkbox" },
  { value: "date", label: "Date" },
  { value: "textarea", label: "Text Area" },
  { value: "pass_fail", label: "Pass / Fail (Inspection)" },
] as const;

export const INSPECTION_RATING_OPTIONS = ["Pass", "Attention", "Fail"] as const;

export const INSPECTION_SECTIONS = [
  "Engine / Powertrain",
  "Hydraulics",
  "Electrical",
  "Undercarriage / Tires",
  "Body / Structure",
  "Safety",
  "Fluids",
  "Attachments",
  "Documentation",
  "General",
] as const;
